import { Text, Grid, Stack, Image } from '@mantine/core';
import { TablerIcon } from '@tabler/icons';
import { useMediaQuery } from '@mantine/hooks';

import React from 'react';
import { createStyles } from '@mantine/emotion';

const iconHeight = 72;

const useStyles = createStyles(() => ({
  iconContainer: {
    minHeight: `${iconHeight}px`,
  },
  paperWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export interface InformationItem {
  Title: string;
  Text: string;
  Icon: TablerIcon;
  Image?: string;
}

interface CardGridProps {
  Items: InformationItem[];
  HasBox?: boolean;
  TextColor?: string;
}

export const CardGrid2: React.FC<CardGridProps> = ({ Items, TextColor }) => {
  const { classes, theme } = useStyles();
  const smallScreen = useMediaQuery('(max-width: 992px)');
  
  const defaultTextColor = TextColor ?? theme.black;

  const getTexts = (item: InformationItem) => {
    return (
      <>
        <Text fw={700} size={'xl'} pt={0} c={defaultTextColor}>
          {item.Title}
        </Text>
        <Text size={'md'} c={defaultTextColor}>
          {item.Text}
        </Text>
      </>
    );
  };

  const handleText = (item: InformationItem) => {
    return getTexts(item);
  };

  return (
    <Grid overflow={'hidden'} gutter={smallScreen ? 60 : 100} m={0} w={'100%'} align={'center'}>
      {Items.map((item, index) => {
        const firstCol = index * 2;
        const imageLeft = index % 2 === 0;

        const imageOrder = imageLeft ? firstCol : firstCol + 1;
        const textOrder = imageLeft ?  firstCol + 1 : firstCol;
        
        return (
          <React.Fragment key={`fragement_${index}`}>
            <Grid.Col key={item.Title + index + '_index'} span={{ sm: 12, md: 4 }}  order={{ base: firstCol + 1, md: imageOrder }} >
              <Stack align={'center'} h={'100%'} gap={0}>
                <div style={{ minHeight: '96px' }}>
                  <Image maw={500} src={item.Image!} style={{ filter: 'grayscale(70%)' }} radius={8}/>
                </div>
              </Stack>
            </Grid.Col>
            <Grid.Col key={item.Title + index + '_text'} span={{ sm: 12, md: 8 }}  order={{ base: firstCol, md: textOrder }}>
              {handleText(item)}
            </Grid.Col>
          </React.Fragment>
        );
      })}
    </Grid>
  );
};
